<script>
/**
 * ****************************************************************************
 * @description     :   Main component for page APP_WorkReport001
 * @created at      :   2025/09/26
 * @created by      :   ANS901 – hainn@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapMutations, mapState, mapActions } from 'vuex';
import store from '@/store';
import APP_WorkReport001_store from '@/views/mobile/app_work_report/APP_WorkReport001/store';
import AnsPanel from '@/components/ansPanel/index.vue';
import APP_WorkReport002 from '@/views/mobile/app_work_report/APP_WorkReport002';
import PopupArea from '@/views/popupSearch/popup_area/store';
/**
 * Import template
 */
import template from './template.html';
import './style.scss';
import helpers from '@/utils/helpers';
/**
 * Define component chat for show page chat
 */
var APP_WorkReport001 = {
    template: template,
    components: {
        AnsPanel,
        APP_WorkReport002,
        PopupArea
    },
    beforeCreate() {
        if (!store.hasModule('APP_WorkReport001')) {
            store.registerModule('APP_WorkReport001', APP_WorkReport001_store);
        }
        if (!store.hasModule('PopupArea')) {
            store.registerModule('PopupArea', PopupArea);
        }
    },
    created() {
        this.setScreenId(this.screenId);
        this.setHeader(this.header);
    },
    mounted() {
        this.setHeader(this.header);
        window.addEventListener('resize', this.handleResize);
    },
    unmounted() {
        this.setHeader();
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            screenId: 'APP_WorkReport001',
            rowActive: null,
            showDetail: false,
            windowWidth: 0,
            type: 1,
            dummyTableData: [
                {
                    chk_box: [0],
                    staff_cd: '880143',
                    staff_nm: '岡本　竣太',
                    type: '現場',
                    mode: 1,
                    office: '船橋オフィス',
                    working_date: '2025/07/29',
                    title_1: '4Days',
                    title_2: '①',
                    msg: '未'
                },
                {
                    chk_box: [0],
                    staff_cd: '880143',
                    staff_nm: '岡本　竣太',
                    type: '現場',
                    mode: 1,
                    office: '船橋オフィス',
                    working_date: '2025/07/29',
                    title_1: '4Days',
                    title_2: '①',
                    msg: '未'
                },
                {
                    chk_box: [0],
                    staff_cd: '880143',
                    staff_nm: '岡本　竣太',
                    type: '現場',
                    mode: 1,
                    office: '船橋オフィス',
                    working_date: '2025/07/29',
                    title_1: '4Days',
                    title_2: '①',
                    msg: '済'
                },
                {
                    chk_box: [0],
                    staff_cd: '880143',
                    staff_nm: '岡本　竣太',
                    type: '現場',
                    mode: 1,
                    office: '船橋オフィス',
                    working_date: '2025/07/29',
                    title_1: '4Days',
                    title_2: '①',
                    msg: '済'
                },
                {
                    chk_box: [0],
                    staff_cd: '880143',
                    staff_nm: '岡本　竣太',
                    type: 'オフィス',
                    mode: 2,
                    office: '船橋オフィス',
                    working_date: '2025/07/29',
                    title_1: '出勤',
                    title_2: '',
                    msg: '未'
                },
                {
                    chk_box: [0],
                    staff_cd: '880143',
                    staff_nm: '岡本　竣太',
                    type: 'オフィス',
                    mode: 2,
                    office: '船橋オフィス',
                    working_date: '2025/07/29',
                    title_1: '公休',
                    title_2: '①',
                    msg: '未'
                }
            ]
        };
    },
    watch: {},
    computed: {
        ...mapState('APP_WorkReport001', ['data', 'options', 'selectOptionKey', 'paginationData', 'searchData']),
        header() {
            const data = {
                title: '業務日報一覧'
            };
            return data;
        },
        isMobile() {
            return helpers.checkIfMobile();
        },
        isIpad() {
            return !(this.windowWidth > 768 && this.windowWidth <= 1366);
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        }
    },
    methods: {
        ...mapMutations('app', [
            'showHeaderError',
            'setScreenId',
            'setHeader',
            'setNotification',
            'showModalMessage',
            'hideModalMessage',
            'hideHeaderError'
        ]),
        ...mapActions('PopupArea', ['searchAreaInfo']),
        referDetail(mode) {
            this.type = mode;
            this.showDetail = !this.showDetail;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        referAreaSearch1(index, value) {
            if (value) {
                this.searchAreaInfo({
                    department_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.staff_id_start = result.department_cd;
                        } else {
                            this.data.staff_id_start = '';
                        }
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                this.data.staff_id_start = '';
            }
        },
        getAreaName1(data) {
            console.log(data);
            // this.data.department_name = data;
        },
        referAreaSearch2(index, value) {
            if (value) {
                this.searchAreaInfo({
                    department_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.staff_id_end = result.department_cd;
                        } else {
                            this.data.staff_id_end = '';
                            this.data.department_name = '';
                        }
                    },
                    onError: (error) => {
                        console.log(error);
                    }
                });
            } else {
                this.data.staff_id_end = '';
            }
        },
        getAreaName2(data) {
            console.log(data);
            // this.data.department_name = data;
        },
        search() {
            this.$store.commit('APP_WorkReport001/setSearchData', this.dummyTableData);
            this.$store.commit('APP_WorkReport001/setPageNavigation', {
                page: 1,
                pageSize: 10,
                totalRows: this.dummyTableData.length
            });
        },
        changeCurrentPage(data) {
            console.log(data);
        },
        checked() {},
        referAreaInfo(index, value) {
            return new Promise((resolve, reject) => {
                if (value) {
                    this.searchAreaInfo({
                        department_cd: value,
                        mode: 1,
                        callback: (response) => {
                            if (response.Data.data.length > 0) {
                                const result = response.Data.data[0];
                                this.data.department_cd = result.department_cd;
                                this.data.department_name = result.department_name;
                            } else {
                                this.data.department_cd = '';
                                this.data.department_name = '';
                            }
                            // refer data form system top
                            const status = this.$route.params.status ?? '';
                            if (status == 23) {
                                this.data.status = 23;
                                this.search();
                            }
                            resolve();
                        },
                        onError: (error) => {
                            console.log(error);
                            reject(error);
                        }
                    });
                } else {
                    this.data.department_cd = '';
                    this.data.department_name = '';
                    resolve();
                }
            });
        },
        getAreaName(data) {
            this.data.department_name = data;
        },
        changeChkAll() {
            const isChecked = this.data.chk_all[0] === 1;
            const newValue = isChecked ? [0] : [1];
            this.data.chk_all = newValue;

            this.searchData.forEach((item) => {
                item.chk_box = newValue.slice();
            });
        },
        updateChkBox(item) {
            item.chk_box = item.chk_box[0] === 1 ? [0] : [1];

            const allChecked = this.searchData.every((it) => it.chk_box[0] === 1);
            const noneChecked = this.searchData.every((it) => it.chk_box[0] === 0);

            if (allChecked) {
                this.data.chk_all = [1];
            } else if (noneChecked) {
                this.data.chk_all = [0];
            } else {
                this.data.chk_all = [];
            }
        }
    }
};
export default APP_WorkReport001;
</script>
